module.exports = __webpack_public_path__ + "img/3.929110be.jpg";